import { MDBContainer, MDBRow } from "mdb-react-ui-kit";

import { ContactUsBanner } from './ContactUsBanner/ContactUsBanner'
import { ContactUsContent } from './ContactUsContent/ContactUsContent'
import React from "react";

export function ContactUs() {

    return (
        <>
            <MDBContainer className={'border border-0 border-danger'}>
                <MDBRow className={'border border-0 border-success mb-5'}>
                    <ContactUsBanner />
                </MDBRow>
                <MDBContainer className={'border border-0 border-danger mb-5'}>
                    <MDBRow className={'border border-0 border-success'}>
                        <ContactUsContent />
                    </MDBRow>
                </MDBContainer>
            </MDBContainer>
        </>
    )
}